import DialogStore from '@/lib/zustand/store/dialogStore';

type DialogProps = {
  name: 'levelUp' | 'newUser';
};
const useDialog = ({ name }: DialogProps) => {
  const isOpen = DialogStore(state => state.isOpen(name));
  const show = DialogStore(state => state.show);
  const hide = DialogStore(state => state.hide);
  const toggle = DialogStore(state => state.toggle);

  return { isOpen, show: () => show(name), hide: () => hide(name), toggle: () => toggle(name) };
};

export default useDialog;
